module.exports = __webpack_public_path__ + "img/scorpion.af0c9613.svg";